import { AddressSelectionContextState } from './address-selection-types';

export const initialAddressSelectionState: AddressSelectionContextState = {
  sender: null,
  contacts: [],
  count: 1,
  maxCount: 0,
  status: {
    isInitialAddress: true,
    isRecipientAddress: false,
    isMaxCountReached: false,
  },
};
